
import { useState } from "react";
import ReportHeader from "./components/ReportHeader";
import ReportTable from "./components/ReportTable";
import Spinner from "../Spin/Spinner";
import { useSelector } from "react-redux";
import { getTransactionThroughPayoutOrderId } from "../../config/LiveApi";

function PayOutReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchType, setSearchType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentItems, setCurrentItems] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [reportType, setReportType] = useState("payout");

  const toggleReportType = () => {
    setReportType((prev) => (prev === "payout" ? "usdt" : "payout"));
    setPage(1);
    setCurrentItems(null);
    setTableData([]);
    setIsSearching(false);
  };

  const token = useSelector((store) => store.userReducer.token);

  const hitFetchApi = async (searchType, searchText) => {
    if (!searchText?.trim()) return;
    setIsSearching(true);
    setIsLoading(true);
    try {
      const response = await getTransactionThroughPayoutOrderId(token, searchText);
      setTableData(response?.transactionDetail);
      setTotalPages(response?.meta?.pagination?.totalPages);
    } catch (error) {
      console.error("Error searching payout transaction:", error.message);
    }
    setIsLoading(false);
  };

  return (
    <div>
      <ReportHeader
        setSearchType={setSearchType}
        searchType={searchType}
        setSearchText={setSearchText}
        searchText={searchText}
        hitFetchApi={hitFetchApi}
        setParentStartDate={setStartDate}
        setParentEndDate={setEndDate}
        reportType={reportType}
        toggleReportType={toggleReportType}
      />

      <div>
        {isLoading ? (
          <Spinner />
        ) : (
          <ReportTable
            currentItems={currentItems || []}
            setCurrentItems={setCurrentItems}
            tableData={tableData || []}
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            startDate={startDate}
            endDate={endDate}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            isSearching={isSearching}
            reportType={reportType}
          />
        )}
      </div>
    </div>
  );
}

export default PayOutReport;